import {AfterViewInit, Component, NgZone, OnInit} from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {UsersService} from "../../core/customers/glotto-users.service";
import {ActivedPromotions} from "../../core/promociones/actived-promotions";
import {MessageService} from "primeng/components/common/messageservice";


declare var $: any;
declare var moment;

@Component({
  selector: 'app-advance-users',
  templateUrl: './advance-users.component.html',
  styleUrls: ['./advance-users.component.scss']
})
export class AdvanceUsersComponent implements OnInit, AfterViewInit {

  selection: string;
  moneyTypeFilter: string;

  startDate = '';
  endDate = '';
  criterios = [];
  activedPromotions: Array<ActivedPromotions> = [];
  selectedUsersCount = 0;
  selectedPromotionKey;
  enrollCustomerSibmitting = false;

  constructor(
    private formBuilder: FormBuilder,
    private zone: NgZone,
    private usersService: UsersService,
    private messageService: MessageService,
  ) {
    this.usersService.getActivedPromotions().subscribe((promotions => {
      this.activedPromotions = promotions;
      this.selectedPromotionKey = promotions[0].promotionKey;
    }));
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    const inputDate = $('#date-input');
    inputDate.daterangepicker({
      autoUpdateInput: false,
      ranges: {
        'HOY': [moment(), moment()],
        'AYER': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'ULTIMOS 7 Days': [moment().subtract(6, 'days'), moment()],
        'ULTIMOS 30 Days': [moment().subtract(29, 'days'), moment()],
        'ESTE MES': [moment().startOf('month'), moment().endOf('month')],
        'MES PASADO': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      locale: {customRangeLabel: 'PERSONALIZADO'}
    });

    inputDate.on('apply.daterangepicker', (ev, picker) => {
      this.startDate = picker.startDate.format('DD-MM-YYYY');
      this.endDate = picker.endDate.format('DD-MM-YYYY');
      inputDate.val(picker.startDate.format('DD-MM-YYYY') + ' - ' + picker.endDate.format('DD-MM-YYYY'));
    });

    inputDate.on('cancel.daterangepicker', (ev, picker) => {
      this.startDate = undefined;
      this.endDate = undefined;
      inputDate.val('');
    });
  }

  onFilterChange(evt) {
    console.log(evt);
    this.selection = evt.target.value;
    this.criterios = [evt.target.value];
    this.moneyTypeFilter = undefined;
    console.log(this.criterios);
  }

  lookUpUsers() {
    this.usersService.lookUpUsers({
      startDate: this.startDate,
      endDate: this.endDate,
      criterios: this.criterios,
      moneyType: this.moneyTypeFilter,
    }).subscribe((number) => {
      this.selectedUsersCount = number;
    });
  }

  enrollCustomerToPromotion() {
    console.log(this.selectedPromotionKey);
    this.enrollCustomerSibmitting = true;
    this.usersService.enrollCustomerToPromotion({
      startDate: this.startDate,
      endDate: this.endDate,
      criterios: this.criterios,
      promotionKey: this.selectedPromotionKey,
      moneyType: this.moneyTypeFilter,
    }).subscribe((number) => {
      this.enrollCustomerSibmitting = false;
      this.messageService.add({
        severity: 'success',
        summary: '',
        detail: 'Se han enrolado los usuarios'
      });
    }, (error) => {
      this.enrollCustomerSibmitting = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrio un error'
      });
    });
  }

  advanceUsersDownloadCsv() {
    return this.usersService.advanceUsersDownloadCsv({
      startDate: this.startDate,
      endDate: this.endDate,
      criterios: this.criterios,
      moneyType: this.moneyTypeFilter,
    }).subscribe((blob) => {
      this.enrollCustomerSibmitting = false;
      this.messageService.add({
        severity: 'success',
        summary: '',
        detail: 'Su descarga comenzara en breve'
      });
      this.downloadFile(blob);
    }, (error) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrio un error'
      });
    });
  }


  downloadFile(blob) {
    const url = window.URL.createObjectURL(blob);
    const anchorElem = document.createElement("a");
    anchorElem.style.display = "none";
    anchorElem.href = url;
    anchorElem.download = `users.csv`;

    document.body.appendChild(anchorElem);
    anchorElem.click();

    document.body.removeChild(anchorElem);

    // On Edge, revokeObjectURL should be called only after
    // a.click() has completed, atleast on EdgeHTML 15.15048
    setTimeout(function () {
      window.URL.revokeObjectURL(url);
    }, 1000);
  }

  onMoneyTypeChange($event) {
    if ($event.target.value == "ALL") {
      this.moneyTypeFilter = undefined;
    } else {
      this.moneyTypeFilter = $event.target.value;
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/advance-users/advance-users.component.ts